import {newUUID} from '../Helper/Helper';

export class RestProcess {
  startTime = new Date();

  id = newUUID();

  constructor(public url: string) {}
}
